export const API_URL = "http://api.bonningues-les-calais.fr";
export const PICTURE_URL = "http://pictures.bonningues-les-calais.fr";
